import { ListItemButton, ListItemText } from '@mui/material';
import { push } from 'utils/navigation/navigate';
import { useContext } from 'react';
import * as React from 'react';
import { LocaleContext } from 'context/locale';
import { useDispatch } from 'react-redux';
import { NavigationSubItemProps } from './NavigationSubitem.types';
import { useMultipeCheckAccess } from 'components/shared/hooks/useCheckAccess/useCheckAccess';

export const NavigationSubItem: React.FC<NavigationSubItemProps> = ({ item, className = '' }) => {
  const { trans } = useContext(LocaleContext);
  const dispatch = useDispatch();
  const showElement = useMultipeCheckAccess(item.resourcesGroups, item.accessType);
  if (!showElement) return null;

  const clickHandler = () => {
    if (item.callback) {
      item.callback(dispatch);
    }
    push(item.path);
  };

  return (
    <ListItemButton className={className} onClick={clickHandler}>
      <ListItemText inset primary={trans(item.label)} />
    </ListItemButton>
  );
};
